import { Pipe, PipeTransform } from '@angular/core'
import {
  ElevatorEngineType,
  ElevatorSpecsEngineType,
} from '@wm-front/client/graphql'

type DeviceEngineType = ElevatorEngineType | ElevatorSpecsEngineType
@Pipe({
  name: 'deviceEngineType',
  standalone: true,
})
export class DeviceEngineTypePipe implements PipeTransform {
  /** Transform device engine type into localised string
   * @param { ElevatorEngineType }
   * @returns { string }
   */
  public transform(value: DeviceEngineType): string {
    switch (value) {
      case ElevatorEngineType.Electric:
      case ElevatorSpecsEngineType.Electric:
        return $localize`:Label | Value for the device type electric@@DeviceEngineTypeElectricLabel:Éléctrique`
      case ElevatorEngineType.Hydraulic:
      case ElevatorSpecsEngineType.Hydraulic:
        return $localize`:Label | Value for the device type hydraulic@@DeviceEngineTypeHydraulicLabel:Hydraulique`
      case ElevatorEngineType.Other:
      case ElevatorSpecsEngineType.Other:
        return $localize`:Label | Value for the device type other@@DeviceEngineTypeOtherLabel:Autre`
      default:
        return $localize`:Label | Value for the device type unvailable@@DeviceEngineTypeUnvailableLabel:Indisponible`
    }
  }
}
